let wuliu = [
	//1
	{
		contactPerson: "朱先生",
		contactTel: "17353226271",
		content: "徐工XR240E一台，要拆开拉",
		createTime: "2021-05-17",
		departure: "重庆市市辖区渝北区",
		departureCityCode: 5001,
		departureDetail: "领航路11号",
		departureDistrictCode: 500112,
		departureProvinceCode: 50,
		destination: "重庆市市辖区合川区",
		destinationCityCode: 5001,
		destinationDetail: "合川工业园区",
		destinationDistrictCode: 500117,
		destinationProvinceCode: 50,
		height: 3,
		id: 20,
		length: 7,
		paid: 1,
		payWay: null,
		pictures: "http://image.hudiejx.com/logisticApply/20210517/e3b92b5fe98d4a32ad21d6ca4a137429.jpg",
		quotation: null,
		status: 3,
		statusName: null,
		title: "26吨旋挖钻机",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 0,
		typeName: "旋挖钻机",
		updateTime: "2021-07-17 14:31:59",
		userId: 4225,
		username: "花式探员",
		weight: 80,
		width: 2,
	},
	//2
	{
		contactPerson: "朱老师",
		contactTel: "1374567529",
		content: "",
		createTime: "2021-06-07",
		departure: "云南省德宏傣族景颇族自治州陇川县",
		departureCityCode: 5331,
		departureDetail: "德宏陇川景罕镇姐冒路6号",
		departureDistrictCode: 533124,
		departureProvinceCode: 53,
		destination: "云南省丽江市永胜县",
		destinationCityCode: 5307,
		destinationDetail: "丽江永胜056乡道纳镇附近",
		destinationDistrictCode: 530722,
		destinationProvinceCode: 53,
		height: 3.3,
		id: 21,
		length: 8,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 2,
		statusName: null,
		title: "26吨重挖掘机",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 1,
		typeName: "挖掘机",
		updateTime: "2021-06-07 17:24:18",
		userId: 4365,
		username: "新用户413",
		weight: 26,
		width: 3.3,
	},
	//3
	{
		contactPerson: "邵先生",
		contactTel: "15380892438",
		content: "平板车，爬坡车",
		createTime: "2021-06-08",
		departure: "安徽省黄山市祁门县",
		departureCityCode: 3410,
		departureDetail: "黄山市祁门024县道西50米（路公桥饭店）",
		departureDistrictCode: 341024,
		departureProvinceCode: 34,
		destination: "安徽省芜湖市弋江区",
		destinationCityCode: 3402,
		destinationDetail: "殷村湖",
		destinationDistrictCode: 340203,
		destinationProvinceCode: 34,
		height: 3,
		id: 22,
		length: 3.5,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 2,
		statusName: null,
		title: "24吨重挖机",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 1,
		typeName: "挖掘机",
		updateTime: "2021-06-08 17:12:52",
		userId: 4365,
		username: "新用户413",
		weight: 24,
		width: 2.3,
	},
	//4
	{
		contactPerson: "刘先生",
		contactTel: "13372648890",
		content: "",
		createTime: "2021-06-08",
		departure: "安徽省宣城市宁国市",
		departureCityCode: 3418,
		departureDetail: "高桥路28号（河沥溪街道办事处）",
		departureDistrictCode: 341881,
		departureProvinceCode: 34,
		destination: "山东省青岛市崂山区",
		destinationCityCode: 3702,
		destinationDetail: "九水东路616号（青岛市天乐弘环卫园林工程有限公司）",
		destinationDistrictCode: 370212,
		destinationProvinceCode: 37,
		height: 4.5,
		id: 23,
		length: 9,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 2,
		statusName: null,
		title: "7吨重大型钢罐",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 9,
		typeName: "大型钢罐",
		updateTime: "2021-06-08 17:21:07",
		userId: 4365,
		username: "新用户413",
		weight: 7,
		width: 4.5,
	},
	//5
	{
		contactPerson: "蒋先生",
		contactTel: "15523449980",
		content: "",
		createTime: "2021-06-09",
		departure: "广东省东莞市东城街道",
		departureCityCode: 4419,
		departureDetail: "东莞",
		departureDistrictCode: 441900003,
		departureProvinceCode: 44,
		destination: "四川省南充市仪陇县",
		destinationCityCode: 5113,
		destinationDetail: "仪陇县",
		destinationDistrictCode: 511324,
		destinationProvinceCode: 51,
		height: 1.5,
		id: 24,
		length: 9.6,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 3,
		statusName: null,
		title: "16吨重农业机械",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 5,
		typeName: "农业机械",
		updateTime: "2021-07-08 16:15:19",
		userId: 4365,
		username: "新用户413",
		weight: 16,
		width: 3.5,
	},
	//6
	{
		contactPerson: "沈",
		contactTel: "15623426000",
		content: "",
		createTime: "2021-06-09",
		departure: "山东省泰安市肥城市",
		departureCityCode: 3709,
		departureDetail: "沙沟村",
		departureDistrictCode: 370983,
		departureProvinceCode: 37,
		destination: "山东省淄博市周村区",
		destinationCityCode: 3703,
		destinationDetail: "新建中路一号（周村古商城）",
		destinationDistrictCode: 370306,
		destinationProvinceCode: 37,
		height: 3.2,
		id: 25,
		length: 7,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 2,
		statusName: null,
		title: "15顿重大型钢罐",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 9,
		typeName: "大型钢罐",
		updateTime: "2021-06-09 11:50:06",
		userId: 4365,
		username: "新用户413",
		weight: 15,
		width: 3.2,
	},
	//7
	{
		contactPerson: "孟先生",
		contactTel: "13025647891",
		content: "",
		createTime: "2021-06-15",
		departure: "山西省太原市阳曲县",
		departureCityCode: 1401,
		departureDetail: "阳曲县",
		departureDistrictCode: 140122,
		departureProvinceCode: 14,
		destination: "内蒙古自治区呼和浩特市土默特左旗",
		destinationCityCode: 1501,
		destinationDetail: "土默特左旗",
		destinationDistrictCode: 150121,
		destinationProvinceCode: 15,
		height: 2.7,
		id: 26,
		length: 12,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 2,
		statusName: null,
		title: "25吨重农业机械",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 5,
		typeName: "农业机械",
		updateTime: "2021-06-15 14:03:29",
		userId: 4365,
		username: "新用户413",
		weight: 25,
		width: 2.7,
	},
	//8
	{
		contactPerson: "明先生",
		contactTel: "18566784665",
		content: "惹急眼了要控制一下就",
		createTime: "2021-07-14",
		departure: "河南省郑州市中原区",
		departureCityCode: 4101,
		departureDetail: "科学研究研究研究",
		departureDistrictCode: 410102,
		departureProvinceCode: 41,
		destination: "辽宁省沈阳市和平区",
		destinationCityCode: 2101,
		destinationDetail: "你嗯破解游戏了自己",
		destinationDistrictCode: 210102,
		destinationProvinceCode: 21,
		height: 5,
		id: 32,
		length: 12,
		paid: 1,
		payWay: 0,
		pictures: "http://image.hudiejx.com/logistic/20210714/8b264baf4d7a43bab9e29dacb63f0e9f.png",
		quotation: null,
		status: 6,
		statusName: null,
		title: "16吨重装载机",
		transactionLogisticsProviderId: 4225,
		transactionPrice: 0.1,
		transactionQuotationId: 28,
		type: 1,
		typeId: 4,
		typeName: "装载机",
		updateTime: "2021-07-14 14:01:44",
		userId: 4434,
		username: "山上吹冷风",
		weight: 18,
		width: 6,
	},
	//9
	{
		contactPerson: "王先生",
		contactTel: "17353226271",
		content: "徐工XR240E一台，要拆开拉",
		createTime: "2021-07-17",
		departure: "重庆市市辖区渝北区",
		departureCityCode: 5001,
		departureDetail: "领航路11号",
		departureDistrictCode: 500112,
		departureProvinceCode: 50,
		destination: "重庆市市辖区綦江区",
		destinationCityCode: 5001,
		destinationDetail: "合川工业园区",
		destinationDistrictCode: 500117,
		destinationProvinceCode: 50,
		height: 3,
		id: 20,
		length: 7,
		paid: 1,
		payWay: null,
		pictures: "http://image.hudiejx.com/logisticApply/20210517/e3b92b5fe98d4a32ad21d6ca4a137429.jpg",
		quotation: null,
		status: 3,
		statusName: null,
		title: "26吨旋挖钻机",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 0,
		typeName: "旋挖钻机",
		updateTime: "2021-07-17 14:31:59",
		userId: 4225,
		username: "花式探员",
		weight: 80,
		width: 2,
	},
	//10
	{
		contactPerson: "张先生",
		contactTel: "13372648890",
		content: "",
		createTime: "2021-07-24",
		departure: "重庆市市辖区渝北区",
		departureCityCode: 3418,
		departureDetail: "高桥路28号（河沥溪街道办事处）",
		departureDistrictCode: 341881,
		departureProvinceCode: 34,
		destination: "重庆市市辖区万州区",
		destinationCityCode: 3702,
		destinationDetail: "九水东路616号（青岛市天乐弘环卫园林工程有限公司）",
		destinationDistrictCode: 370212,
		destinationProvinceCode: 37,
		height: 4.5,
		id: 23,
		length: 9,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 2,
		statusName: null,
		title: "7吨重大型钢罐",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 9,
		typeName: "大型钢罐",
		updateTime: "2021-06-08 17:21:07",
		userId: 4365,
		username: "新用户413",
		weight: 7,
		width: 4.5,
	},
	//11
	{
		contactPerson: "黄先生",
		contactTel: "15523449980",
		content: "",
		createTime: "2021-08-02",
		departure: "重庆市市辖区渝北区",
		departureCityCode: 4419,
		departureDetail: "东莞",
		departureDistrictCode: 441900003,
		departureProvinceCode: 44,
		destination: "湖北省武汉市江岸区",
		destinationCityCode: 5113,
		destinationDetail: "仪陇县",
		destinationDistrictCode: 511324,
		destinationProvinceCode: 51,
		height: 1.5,
		id: 24,
		length: 9.6,
		paid: 1,
		payWay: null,
		pictures: "",
		quotation: null,
		status: 3,
		statusName: null,
		title: "16吨重农业机械",
		transactionLogisticsProviderId: null,
		transactionPrice: null,
		transactionQuotationId: null,
		type: 0,
		typeId: 5,
		typeName: "农业机械",
		updateTime: "2021-07-08 16:15:19",
		userId: 4365,
		username: "新用户413",
		weight: 16,
		width: 3.5,
	},
]

module.exports = {
	wuliu: wuliu
}
